module.exports = __webpack_public_path__ + "img/Feature-4.2fb54ab.svg";